import(/* webpackMode: "eager" */ "/var/www/vhosts/sundaytowers.am/httpdocs-new/sundaytowers-front/src/app/[lang]/[...not-found]/page.js");
